const MasterCard = () => {
  return (
    <svg
      width="23"
      height="16"
      viewBox="0 0 23 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="21.1769" height="15" rx="3.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="21.1769"
        height="15"
        rx="3.5"
        stroke="#CFCFCF"
      />
      <path
        d="M13.2769 4.07007H8.90389V11.9275H13.2769V4.07007Z"
        fill="#FF5F00"
      />
      <path
        d="M9.18154 7.99884C9.18154 6.47177 9.88955 5.01411 11.0834 4.07011C8.91777 2.36256 5.76646 2.73739 4.05891 4.91694C2.36525 7.0826 2.74008 10.22 4.91963 11.9276C6.73823 13.3575 9.27872 13.3575 11.0973 11.9276C9.88955 10.9836 9.18154 9.52591 9.18154 7.99884Z"
        fill="#EB001B"
      />
      <path
        d="M19.1769 7.99884C19.1769 10.7615 16.9418 12.9965 14.1792 12.9965C13.0547 12.9965 11.9719 12.6217 11.0973 11.9276C13.263 10.22 13.6378 7.0826 11.9303 4.90305C11.6804 4.59764 11.4027 4.30611 11.0973 4.07011C13.263 2.36256 16.4143 2.73739 18.108 4.91694C18.8021 5.79153 19.1769 6.87436 19.1769 7.99884Z"
        fill="#F79E1B"
      />
    </svg>
  );
};
export default MasterCard;
